export const rotateAllImagesToVertical = async (imagesInBase64: string[]): Promise<string[]> => {
    const promiseArray: Promise<void>[] = [];
    const verticallyRotatedImagesInBase64: string[] = [];

    imagesInBase64.forEach(imageInBase64 => {
      promiseArray.push(new Promise(resolve => {
        let img: HTMLImageElement = new Image();
        img.onload = () => {
          if (img.width > img.height) {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.width = img.height;
            canvas.height = img.width;

            ctx!.rotate(90 * (Math.PI / 180));
            ctx!.translate(0, -canvas.width);
            ctx!.drawImage(img, 0, 0);
            let rotatedImageInBase64: string = canvas.toDataURL(
              "image/jpeg",
              0.8
            );
            verticallyRotatedImagesInBase64.push(rotatedImageInBase64);
            resolve();
          } else {
            verticallyRotatedImagesInBase64.push(imageInBase64);
            resolve();
          }
        };

        img.src = imageInBase64;
      }));
    });

    await Promise.all(promiseArray);

    return verticallyRotatedImagesInBase64;
  };

export const resizeAndCompressImages = async (imagesInBase64: string[]): Promise<string[]> => {
    const promiseArray: Promise<void>[] = [];
    const resizedAndCompressedImagesInBase64: string[] = [];
   
    imagesInBase64.forEach(imageInBase64 => {
      promiseArray.push(new Promise(resolve => {
        let img: HTMLImageElement = new Image();
        img.onload = () => {
          resizedAndCompressedImagesInBase64.push(resizeAndCompressImage(img, img.width, img.height));
          resolve();
        };

        img.src = imageInBase64;
      }))
    });

    await Promise.all(promiseArray);

    return resizedAndCompressedImagesInBase64;
  };

  const resizeAndCompressImage = (img: HTMLImageElement, originalWidth: number, originalHeight: number): string => {
    console.log('Resizing and compressing')

    // create an off-screen canvas
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");

    const targetMaxDimension: number = 1500;

    const maxDimension: number = Math.max(originalWidth, originalHeight);

    const scaleRatio: number = targetMaxDimension / maxDimension;

    // set its dimension to target size
    canvas.width = originalWidth * scaleRatio;
    canvas.height = originalHeight * scaleRatio;
  
    // draw source image into the off-screen canvas:
    ctx!.drawImage(img, 0, 0, canvas.width, canvas.height);
  
    // encode image to data-uri with base64 version of compressed image
    return canvas.toDataURL("image/jpeg", 0.8);
  };

export const cropImage = async (imagesInBase64: string[]): Promise<string[]> => {
  const promiseArray: Promise<void>[] = [];
  const croppedImagesInBase64: string[] = [];

  imagesInBase64.forEach(imageInBase64 => {
    promiseArray.push(new Promise(resolve => {
      let img: HTMLImageElement = new Image();
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");

        const desiredAspectRatio: number = 3.0 / 4.0; 
        const imgAspectRatio: number = img.width / img.height;
  
        let width: number, height: number, yOffset: number;

        if (imgAspectRatio < desiredAspectRatio) {
          // Image is too tall, crop from top and bottom
          width = img.width;
          height = img.width / desiredAspectRatio;
        
          yOffset = (img.height - height) / 2;
          canvas.width = width;
          canvas.height = height;
          ctx!.drawImage(img, 0, yOffset, width, height, 0, 0, width, height);

          const croppedBase64 = canvas.toDataURL('image/jpeg', 0.8);
          croppedImagesInBase64.push(croppedBase64);
        } else {
          croppedImagesInBase64.push(imageInBase64);
        }

        resolve();
      };
      img.src = imageInBase64;
    }))
  });
  await Promise.all(promiseArray);

  return croppedImagesInBase64;
};
